{
  class OrderSplitter extends HTMLElement {
    constructor() {
      super()
      this.attachShadow({ mode: 'open' })

      // these are selectors on which this functionality should run
      this.checkoutSelectors = [
        '#checkout', // cart page submit button
      ]

      // there is not a good way to handle enabling/disabling these
      this.alwaysHideSelectors = [
        '#cart-notification-form', // popup form when a product is added to cart
      ]

      // some items in shopify submit no matter what we do
      // so we just need to hide them so users can't avoid this process
      this.cartPageHideSelectors = [
        '.cart__footer shopify-accelerated-checkout-cart',  // cart page custom element
      ]

      this.refreshDataSelectors = [
        '.quantity__button',
        'cart-remove-button a'
      ]
      
      this.mustShipProducts = []
      this.mustLocalPickupProducts = []
    }

    connectedCallback() {
      this.alwaysHideSelectors.map(sel => document.querySelector(sel)).filter(x => x).forEach(el => el.style.display = 'none')

      this.handleStoredProducts()

      document.addEventListener('click', (e) => {
        if(e?.currentTarget?.tagName == "ORDER-SPLITTER"){
          this.shadowRoot.innerHTML = ``
        }

        const checkoutElement = this.checkoutSelectors.map(selector => e.target.closest(selector)).find(el => el)
        if (checkoutElement) {
          if(this.mustShipProducts.length && this.mustLocalPickupProducts.length) {
            e.preventDefault()
            e.stopImmediatePropagation()
            e.stopPropagation()
            this.showMustSplitOrderMessage()  
          }
        }

        // these will disable cart submission and then wait for the this.observer to turn it back on when AJAX finishes
        const refreshElement = this.refreshDataSelectors.map(selector => e.target.closest(selector)).find(el => el)
        if(refreshElement){
          this.checkoutSelectors.map(sel => document.querySelector(sel)).filter(x => x).forEach(el => {
            el.innerText = "Loading..."
            el.setAttribute('disabled', true)
          })
        }
      }, true)

      this.observer = new PerformanceObserver((list) => {
        for (const entry of list.getEntries()) {
          if(entry.name.includes('cart/change') || entry.name.includes('cart/add') ){
            this.initializeData()
          }
        }
      });

      this.observer.observe({ entryTypes: ["resource"] });

      this.initializeData()
    }

    async initializeData(){

      this.checkoutSelectors.map(sel => document.querySelector(sel)).filter(x => x).forEach(el => {
        el.innerText = "Loading..."
        el.setAttribute('disabled', true)
      })  

      const response = await fetch('/cart.js');
      const cart = await response.json();

      this.mustShipProducts = []
      this.mustLocalPickupProducts = []

      for (const item of cart?.items || []) {
        const productRes = await fetch(`/products/${item.handle}.js`);
        const productJson = await productRes.json();
        if (productJson?.tags?.includes('ShippingOnly')) {
          const obj = {
            cartItem: item.id,
            quantity: item.quantity,
            title: item.product_title,
            product: item.product_id,
            variant: item.variant_id
          }
          this.mustShipProducts.push(obj);
        } else {
          const obj = {
            cartItem: item.id,
            quantity: item.quantity,
            title: item.product_title,
            product: item.product_id,
            variant: item.variant_id
          }
          this.mustLocalPickupProducts.push(obj);
        }
      }

      if(this.mustLocalPickupProducts.length && this.mustShipProducts.length){
        this.cartPageHideSelectors.map(sel => document.querySelector(sel)).filter(x => x).forEach(el => el.style.display = 'none')
      } else {
        this.cartPageHideSelectors.map(sel => document.querySelector(sel)).filter(x => x).forEach(el => el.style.display = '')
      }

      this.checkoutSelectors.map(sel => document.querySelector(sel)).filter(x => x).forEach(el => {
        el.innerText = "Check out"
        el.removeAttribute('disabled')
      })

      return
    }    

    async handleStoredProducts(){
      const storedProducts = JSON.parse(localStorage.getItem('orderSplitterMustShipProducts') || '[]');
      if(storedProducts.length){
        this.shadowRoot.innerHTML = `
          ${this.getStyle()}
          <div class="loader">
            <div class="spinner"></div>
            <div class="message">Checking product shipping options...</div>
          </div>
        `;

        const updates = Object.fromEntries(storedProducts.map(p => [p.variant, p.quantity]));
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        })
        
        localStorage.removeItem('orderSplitterMustShipProducts')

        const response = await fetch('/cart.js')
        const cart = await response.json()
        let hasMustShipProducts = false
        let hasMustLocalPickupProducts = false

        for (const item of cart?.items || []) {
          const productRes = await fetch(`/products/${item.handle}.js`);
          const productJson = await productRes.json();
          if (productJson?.tags?.includes('ShippingOnly')) {
            hasMustShipProducts = true
          } else {
            hasMustLocalPickupProducts = true
          }
        }

        if(hasMustShipProducts && hasMustShipProducts){
          // just refresh... this means they abandoned checkout so we just re-add their stored products and let them do whatever
          window.location.reload()
        } else {
          window.location.href = "/cart/checkout"
        }
      }
      return
    }

    getStyle(){
      return `<style>
        :host {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.7);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 9999;
        }
        .loader {
          display: flex;
          flex-direction: column;
          align-items: center;
          background: white;
          padding: 20px;
          border-radius: 10px;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
          max-width: 768px;
        }
        .loader .message {
          margin: 20px auto;
        }
        .loader .flex-container {
          display: flex;
          gap: 1rem;
          & > * {
            width: 100%;
          }
        }
        .loader button.confirm {
          border: 0;
          padding: 1rem 2rem;
          border-radius: 0;
          background: rgb(85, 118, 48);
          color: white;
          width: 100%;
          font-size: 18px;
          margin-top: 2rem;
          transition: 250ms;
          cursor: pointer;
          font-family: var(--font-body-family);
        }
        .loader button:hover,
        .loader button:focus {
          opacity: 0.65;
        }
        .loader .spinner {
          border: 4px solid rgba(255, 255, 255, 0.3);
          border-radius: 50%;
          border-top: 4px solid #007bff;
          width: 40px;
          height: 40px;
          animation: spin 1s linear infinite;
        }
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      </style>`
    }

    showMustSplitOrderMessage(){
      this.shadowRoot.innerHTML = `
        ${this.getStyle()}
        <div class="loader">
          <div class="message">
            <div style="text-align:right"><button class="cancel">&times; Close</buttom></div>
            <h2>Order Notice</h2>
            <p>Your cart contains products that must be shipped and products that must be picked up locally.</p>
            <p>Before you checkout we will split these products into two separate orders.</p>
            <p>After completing your first order, return to the site and you will automatically be redirected to checkout with the second order.</p>
            <div class="flex-container">
              <div>
                <p>Products requiring local pickup:</p>
                <ul>
                  ${this.mustLocalPickupProducts.map(p => `<li>${p.title}</li>`).join('')}
                </ul>
              </div>
              <div>
                <p>Products requiring shipping:</p>
                <ul>
                  ${this.mustShipProducts.map(p => `<li>${p.title}</li>`).join('')}
                </ul>
              </div>
            </div>
            <div style="text-align:center">
              <button class="confirm">Confirm & Checkout</button>
            </div>
          </div>
        </div>
      `;

      this.shadowRoot.querySelector('.confirm').addEventListener('click', () => this.confirmAndCheckout());
      this.shadowRoot.querySelector('.cancel').addEventListener('click', () => this.shadowRoot.innerHTML = ``);
    }

    async confirmAndCheckout() {
      localStorage.setItem('orderSplitterMustShipProducts', JSON.stringify(this.mustShipProducts));

      const updates = Object.fromEntries(this.mustShipProducts.map(p => [p.variant, 0]));

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });

      window.location.href = "/cart/checkout"
      return
    }
  }

  customElements.define('order-splitter', OrderSplitter)
  const loader = document.createElement('order-splitter')
  document.body.appendChild(loader)
}